import { useQuery, UseQueryResult } from "react-query";
import { ChatHttpService } from "../services";

interface ConversationsListProps {
  page?: number;
  pageSize?: number;
}

type ConversationsData = any; // Replace with your actual data type

function useConversationsList({
  page = 1,
  pageSize = 30,
}: ConversationsListProps): UseQueryResult<ConversationsData, unknown> {
  const queryResult = useQuery<ConversationsData, unknown>(
    ["conversations_list", page, pageSize],
    () => ChatHttpService.loadConversations({ page, pageSize }),
    {
      onSuccess: (data) => {
        // You can perform side effects with the loaded data here.
        // For example: console.log("Loaded conversations:", data);
      },
    }
  );

  if(queryResult.data){
    return queryResult.data;
  }

  return queryResult;
}

export default useConversationsList;
